import axios from '../../../../utils/request';

function GET_AROLE(params) {
    return axios.get("/dictionary/AServerYear/index",{
        params: {
            page:params
        }
    } )
}
function SUBMIT_ADD(params) {
    return  axios.post("/dictionary/AServerYear/addPost",{...params} )
}
function EDIT_DATA(params) {
    return  axios.post("/dictionary/AServerYear/edit",  {
            ...params
        }  )
}
function SUBMIT_EDIT(params) {
    return  axios.post("/dictionary/AServerYear/editPost",{...params} )
}
function DELE(params) {
    return  axios.get("/dictionary/AServerYear/delete",{
        params: {
            ids:params
        }
    } )
}


export default {
    GET_AROLE,
    SUBMIT_ADD,
    EDIT_DATA,
    SUBMIT_EDIT,
    DELE,
};